import React from 'react'

const QuestionSolidIcon = () => {
	return (
		<svg width={25} height={25} viewBox='0 0 25 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<circle
				cx={12.5}
				cy={12.5}
				r={11.5}
				fill='currentColor'
				stroke='currentColor'
				strokeWidth={2}
			/>
			<path
				d='M11.62 15.598c.012-.762.098-1.364.257-1.806.159-.442.483-.932.973-1.47l1.25-1.297c.534-.608.802-1.261.802-1.96 0-.672-.175-1.197-.525-1.575-.35-.384-.859-.576-1.527-.576-.649 0-1.17.172-1.565.518-.394.346-.591.81-.591 1.393H8.929c.012-1.037.378-1.873 1.097-2.507.725-.64 1.667-.96 2.824-.96 1.203 0 2.138.326 2.805.98.675.646 1.012 1.536 1.012 2.67 0 1.12-.515 2.226-1.546 3.314l-1.04 1.038c-.464.519-.696 1.265-.696 2.238h-1.766zm-.077 3.046c0-.288.086-.529.258-.72.178-.2.439-.299.782-.299.344 0 .604.1.783.298.178.192.267.433.267.72 0 .289-.09.53-.267.721-.179.186-.44.279-.783.279s-.604-.093-.782-.279a1.04 1.04 0 01-.258-.72z'
				fill='#fff'
			/>
		</svg>
	)
}

export default QuestionSolidIcon
